// Angular
import { Component, OnInit ,Input} from '@angular/core';

// Data/Classes/Others
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserIFace } from 'src/app/shared/classes';


import { AdminService } from 'src/app/services/admin/admin.service';
import { MessagesService } from 'src/app/services/message/messages.service';
import { WHAT } from 'src/app/shared/classes';

declare var moment: any;

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.less']
})

export class UserDetailsComponent implements OnInit {
   @Input() user: UserIFace;
   public showUser = true;

    public allSummaries = {
        projects: '',
        applications: '',
        groups: '',
        devices: '',
        device_online:'',
      };

    constructor(private admin: AdminService, private msg: MessagesService, private ngbModal: NgbModal) { }      
    
    ngOnInit() {
        this.getSummaryData();
      }

    private getSummaryData(){
      this.admin.GET(WHAT.userDetails,"","",this.user.data.user_id,this.user.data.readWriteAPI)
      .then(res => this.processResponse(res))
      .catch(error => this.handleError(error));
    }

    private processResponse(res) {
       this.allSummaries.projects = res.projects;
       this.allSummaries.applications = res.applications;
       this.allSummaries.groups = res.groups;
       this.allSummaries.devices = res.devices;
       this.allSummaries.device_online=res.device_online;
    }
      // handle error
    private handleError(error) {
      this.msg.error(error);
   }
}
